import * as React from 'react';

var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgSmMailMonochrome = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 9.143c0-.834.328-1.633.911-2.222A3.095 3.095 0 0 1 6.111 6H27.89c.825 0 1.616.331 2.2.92A3.16 3.16 0 0 1 31 9.144v15.714a3.16 3.16 0 0 1-.911 2.223c-.584.589-1.375.92-2.2.92H6.11a3.095 3.095 0 0 1-2.2-.92A3.16 3.16 0 0 1 3 24.857V9.143Z",
  fill: "#77819C"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.05,
  d: "M3 9.143c0-.834.328-1.633.911-2.222A3.095 3.095 0 0 1 6.111 6H27.89c.825 0 1.616.331 2.2.92A3.16 3.16 0 0 1 31 9.144v15.714a3.16 3.16 0 0 1-.911 2.223c-.584.589-1.375.92-2.2.92H6.11a3.095 3.095 0 0 1-2.2-.92A3.16 3.16 0 0 1 3 24.857V9.143Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m14.48 16.45 1.278.837a2.274 2.274 0 0 0 2.485 0l1.277-.837L31 23.966v.891a3.16 3.16 0 0 1-.911 2.223 3.096 3.096 0 0 1-2.182.92H6.093a3.096 3.096 0 0 1-2.182-.92A3.16 3.16 0 0 1 3 24.857v-.89l11.48-7.517Z",
  fill: "#08031D"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m3.006 8.938 12.751 8.348a2.274 2.274 0 0 0 2.485 0l12.751-8.348a3.157 3.157 0 0 0-.904-2.017 3.095 3.095 0 0 0-2.2-.921H6.11c-.825 0-1.617.331-2.2.92a3.157 3.157 0 0 0-.905 2.018Z",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.24 10.065 17 18.1l11.76-8.035",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export { SvgSmMailMonochrome as default };
